<h2 mat-dialog-title>
    {{ s_id ? 'Update Sponsor' : 'Add Sponsor' }}
</h2>

<form [formGroup]="SponsorForm" (ngSubmit)="onFormSubmit()">

    <mat-dialog-content class="content">

        <div class="row mb-4">
            <div class="col-9">
                <mat-label>Logo</mat-label>
                <div class="input-group">
                    <input type="file" class="form-control" id="inputGroupFile01" #file accept='image/*'
                        id="exampleInputFile" (change)="previewpimage(file.files)">
                </div>
            </div>

            <div class="col-3">
                <div *ngIf="!isOld1">
                    <img src="https://aieventzo.com/upload/{{event_id}}/sponsor/{{this.imagePath}}"
                        style="width: 80px;height: 80px;border-radius: 10px;">
                </div>
                <div *ngIf="isOld1">
                    <img src="https://aieventzo.com/upload/{{event_id}}/sponsor/{{image_name}}"
                        style="width: 80px;height: 80px;border-radius: 10px;">
                </div>
            </div>


        </div>

        <div class="column">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Sponsor Name</mat-label>
                <input matInput placeholder="Enter Sponsor Name" [ngModel]="sponsor_name"
                    formControlName="sponsor_name">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Mobile</mat-label>
                <input [ngModel]="mobile" formControlName="mobile" maxlength="10" matInput
                    placeholder="Enter Your Mobile Number">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Category</mat-label>
                <input [ngModel]="category" formControlName="category" matInput placeholder="Enter Your Category">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Website</mat-label>
                <input [ngModel]="website" formControlName="website" matInput placeholder="Enter Your Website">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Amount</mat-label>
                <input [ngModel]="amount" formControlName="amount" matInput placeholder="Enter Your Amount">
            </mat-form-field>
        </div>


    </mat-dialog-content>

    <mat-dialog-actions class="action" align="end">
        <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">
            Cancel
        </button>

        <button mat-raised-button type="submit" color="primary">
            {{ s_id ? 'Update' : 'Add' }}
        </button>
    </mat-dialog-actions>

</form>